import { JOURNEY_STEPS } from '@/data/content';
import { Reveal } from '@/components/Reveal';
import { scrollToId } from '@/lib/scroll';
import { trackEvent } from '@/lib/analytics';

export const OneTeam = () => (
  <section data-testid="one-team-section" className="py-24 sm:py-32 relative overflow-hidden">
    <div className="max-w-7xl mx-auto px-5 sm:px-8 text-center">
      <Reveal>
        <p className="caption-label mb-4">Chapter 03 — The Promise</p>
        <h2 className="font-serif text-3xl sm:text-4xl md:text-6xl font-light tracking-tight text-cream leading-tight">
          Everything You Need. <span className="italic text-champagne">One Team.</span>
        </h2>
        <p className="mt-6 text-base md:text-lg text-white/60 font-light tracking-wide max-w-2xl mx-auto">
          One Team. One Point of Contact. Complete Peace of Mind. You will never have to coordinate
          with multiple vendors again.
        </p>
      </Reveal>

      <div className="mt-16 flex flex-wrap items-center justify-center gap-y-4" data-testid="journey-flow">
        {JOURNEY_STEPS.map((step, i) => (
          <Reveal key={step} delay={i * 0.06} y={20} className="flex items-center">
            <span className="group relative px-4 sm:px-5 py-3 border border-white/15 text-xs sm:text-sm uppercase tracking-[0.2em] text-white/70 hover:border-champagne hover:text-champagne transition-colors duration-300">
              {step}
            </span>
            {i < JOURNEY_STEPS.length - 1 && (
              <span className="hidden sm:block w-6 h-px bg-champagne/50 mx-1" />
            )}
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.3} className="mt-14">
        <button
          data-testid="one-team-quote-btn"
          onClick={() => { trackEvent('enquire_click', { location: 'one_team' }); scrollToId('#enquiry'); }}
          className="btn-outline"
        >
          Get Your Free Quote
        </button>
      </Reveal>
    </div>
  </section>
);
